import React from "react";
export default function StudentReports() {
  return (
    <div className="dashboard-wrapper">
      <h2>Reports & Analytics</h2>
      <p>View student statistics and generate reports here.</p>
      {/* Implement reports/analytics here */}
    </div>
  );
}